import React, { useCallback, useEffect } from 'react';

import { Box } from '@mui/material';
import { TextFieldCDS } from '@sharedCR/coreDesignSystem/form';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../../../LoanFees.testIds';
import {
  MAX_LENGTH_REASON_NOTE,
  TEXTAREA_ROWS_REASON_NOTE,
} from '../CicFeeReasonEditItem.constants';
import { formWrapperStyles } from '../CicFeeReasonEditItem.styles';

const DeleteReasonForm = ({ formContext, formRef, reason }) => {
  const { form, validationErrors, setInForm, validateField, handleChange, validateForm } =
    formContext;

  const { loanCicFeeChangeReasonId } = reason;

  const deletionReasonPath = `${loanCicFeeChangeReasonId}.deletionReason`;
  const deletionReasonValue = _.get(form, deletionReasonPath, '');
  const deletionReasonError = _.get(validationErrors, deletionReasonPath, '');

  useEffect(() => {
    setInForm(deletionReasonPath, '');
  }, [deletionReasonPath, loanCicFeeChangeReasonId, setInForm]);

  useEffect(() => {
    if (!formRef) {
      return;
    }

    formRef.current = { formData: form, validateForm };
  }, [formRef, form, validateForm]);

  const onBlur = useCallback(
    e => {
      validateField(e.target.name, e.target.value);
    },
    [validateField],
  );

  return (
    <Box data-testid={LoanFeesTestIds.DELETE_CIC_REASON_MODAL_CONTENT} sx={formWrapperStyles}>
      <TextFieldCDS
        multiline
        required
        dataTestId={LoanFeesTestIds.DELETE_CIC_REASON_INPUT}
        error={!!deletionReasonError}
        helperText={deletionReasonError}
        label="Deletion Reason"
        maxLength={MAX_LENGTH_REASON_NOTE}
        name={deletionReasonPath}
        placeholder={`${MAX_LENGTH_REASON_NOTE} max character limit`}
        rows={TEXTAREA_ROWS_REASON_NOTE}
        value={deletionReasonValue}
        onBlur={onBlur}
        onChange={handleChange}
      />
    </Box>
  );
};

DeleteReasonForm.propTypes = {
  reason: PropTypes.shape({
    loanCicFeeChangeReasonId: PropTypes.string.isRequired,
  }).isRequired,
  formContext: PropTypes.shape({
    form: PropTypes.object.isRequired,
    validationErrors: PropTypes.object.isRequired,
    setInForm: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    validateForm: PropTypes.func.isRequired,
  }).isRequired,
  formRef: PropTypes.shape({
    current: PropTypes.object,
  }),
};

export default DeleteReasonForm;
